export default __webpack_public_path__ + "images/models/bfc796a1b9377eb4c0bc035137d016b8.usdz";